module.exports = __webpack_public_path__ + "img/l-04.fbb09938.png";